import React, { useState, useEffect, useCallback, useMemo } from 'react';
import { Modal, ModalHeader, Nav, NavItem, NavLink } from 'reactstrap';
import classnames from 'classnames';
import EstablishmentForm from '../Forms/EstablishmentForm';

const AddEditEstablishmentModal = ({
	dataEstablishment,
	isOpen,
	isEdit,
	handleToggleModal,
	activeTab,
	toggleTab,
}) => {
	return (
		<Modal
			isOpen={isOpen}
			toggle={handleToggleModal}
			size='xl'
			className='border-0'
			modalClassName='modal fade zoomIn'
			backdrop={'static'}
			centered={true}
		>
			<ModalHeader toggle={handleToggleModal}>
				{isEdit ? 'Editar' : 'Agregar'} Establecimiento
			</ModalHeader>

			<div className='modal-content border-0 mt-3'>
				<Nav className='nav-tabs nav-tabs-custom nav-success p-2 pb-0 bg-light'>
					<NavItem>
						<NavLink href='#' className={classnames({ active: activeTab === '1' })} onClick={() => { toggleTab('1'); }}>Información General</NavLink>
					</NavItem>
					<NavItem>
						<NavLink href='#' className={classnames({ active: activeTab === '2' })} onClick={() => { toggleTab('2'); }}>Códigos del Establecimiento</NavLink>
					</NavItem>
					<NavItem>
						<NavLink href='#' className={classnames({ active: activeTab === '3' })} onClick={() => { toggleTab('3'); }}>Información de la Ubicación</NavLink>
					</NavItem>
					<NavItem>
						<NavLink href='#' className={classnames({ active: activeTab === '4' })} onClick={() => { toggleTab('4'); }}>Establecimiento Relacionados</NavLink>
					</NavItem>
					<NavItem>
						<NavLink href='#' className={classnames({ active: activeTab === '5' })} onClick={() => { toggleTab('5'); }}>Movimientos de Bodega</NavLink>
					</NavItem>
				</Nav>
			</div>

			<EstablishmentForm
				dataEstablishment={dataEstablishment}
				isOpen={isOpen}
				isEdit={isEdit}
				handleToggleModal={handleToggleModal}
				activeTab={activeTab}
				toggleTab={toggleTab}
			/>
		</Modal>
	);
};

export default AddEditEstablishmentModal;
